/** @typedef {import('../../types/auth').MerchantUser} MerchantUser */
/** @typedef {import('../../types/team').Role} Role */

import { useEffect, useState } from 'react';
import { useQuery } from 'react-query';

import { fetchRoles, fetchTeamMembers } from '../../api/';
import { handleQueryError } from '../../utils';

/** @returns {{ isFetching: boolean, isLoading: boolean, isRefetching: boolean, teamMembers: MerchantUser[], refetch: Function }} */
const useFetchTeam = () => {
  const [teamMembers, setTeamMembers] = useState([]);

  const { isFetching, isLoading, isError, data, refetch, isRefetching, error } = useQuery(
    'teamMembers',
    fetchTeamMembers
  );

  if (isError) {
    handleQueryError(error, 'teamMembers');
  }

  useEffect(() => {
    if (data && data.data) {
      setTeamMembers(data.data);
    }
  }, [data]);

  return {
    isFetching,
    isLoading,
    isRefetching,
    teamMembers,
    refetch
  };
};

/** @returns {{ isFetching: boolean, isLoading: boolean, isRefetching: boolean, roles: Role[] }} */
const useFetchRoles = () => {
  const [roles, setRoles] = useState([]);

  const { isFetching, isLoading, isError, data, refetch, isRefetching, error } = useQuery(
    'roles',
    fetchRoles
  );

  if (isError) {
    handleQueryError(error, 'roles');
  }

  useEffect(() => {
    if (data && data.data) {
      console.log('Data');
      setRoles(data.data);
    }
  }, [data]);

  return {
    isFetching,
    isLoading,
    isRefetching,
    roles
  };
};

export { useFetchRoles, useFetchTeam };
